<template>
    <div class="loader-svg" :class="{ loaded: !isShow }">
        <div class="loading">
            <img src="@/assets/ssoauth/loading.svg" alt="" />
            <p>Loading</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Loading",
    props: {
        isShow: Boolean
    },
    data: function() {
        return {};
    },
    created() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.loader-svg {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 52%);
    color: #fff;
    text-align: center;
    z-index: 99999;
    &.loaded {
        display: none;
    }
    .loading{
        position: fixed;
        width: 100px;
        height: 100px;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 2;
        background: #fff;
        border-radius: 5px;
        color: #65513e;
        padding: 10px 0;
        text-align: center;
        img{
            width: 60px;
        }
        p{
            margin: 0;
        }
    }
}
</style>
